
























import { defineComponent } from "@vue/composition-api";
import { InputUserUpdate, User } from "@scrile/api-provider/dist/api/UserProvider";
import useAuthUser from "@/hooks/useAuthUser";
import providers from "@/lib/api";
import BaseButton from "@/components/BaseButton";
import BaseInput from "@/components/BaseInput";
import PageTitle from "@/components/PageTitle";

export default defineComponent({
  name: "SignUpEmailConfirm",
  components: { BaseInput, BaseButton, PageTitle },
  setup() {
    const { authUser, setSocialLoginStatus, updateUser } = useAuthUser();
    return {
      authUser,
      setSocialLoginStatus,
      updateUser,
    };
  },
  data() {
    return {
      currentEmail: "",
      loading: false,
      isValid: false,
    };
  },
  computed: {
    email: {
      get(): string {
        if (this.currentEmail !== "") return this.currentEmail;
        return (this.authUser && this.authUser.email) || "";
      },
      set(value: string) {
        this.currentEmail = value;
      },
    },
    user(): User {
      return this.authUser as User;
    },
  },
  methods: {
    async submit() {
      if (!this.isValid) return;
      this.loading = true;
      const data: InputUserUpdate = {
        id: this.user.id,
        email: this.email,
      };
      try {
        const user = await providers.UserProvider.update({ data });
        this.setSocialLoginStatus(false);
        this.updateUser(user);
        this.$emit("confirm");
      } finally {
        this.loading = false;
      }
    },
  },
});
